import * as React from 'react';

export interface SignOutIconProps {
  size?: number;
  fill?: string;
}

export const SignOutIcon: React.FunctionComponent<SignOutIconProps> = ({ size = 24, fill = '#000' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={size} width={size}>
      <path
        d="M15.225 16.475q-.325-.375-.325-.838 0-.462.325-.787l1.725-1.7h-6.925q-.475 0-.8-.338Q8.9 12.475 8.9 12q0-.475.325-.812.325-.338.8-.338h6.925l-1.725-1.7q-.35-.35-.338-.813.013-.462.338-.812.325-.325.788-.325.462 0 .787.325l3.7 3.675q.15.175.225.375.075.2.075.425 0 .225-.075.425-.075.2-.225.375l-3.7 3.7q-.375.35-.812.312-.438-.037-.763-.337ZM5 21.2q-.95 0-1.612-.662-.663-.663-.663-1.613V5.075q0-.95.663-1.613Q4.05 2.8 5 2.8h5.9q.5 0 .825.325.325.325.325.8 0 .5-.325.825-.325.325-.825.325H5v13.85h5.9q.5 0 .825.325.325.325.325.825 0 .475-.325.8-.325.325-.825.325Z"
        fill={fill}
      />
    </svg>
  );
};
